var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import { Chip, TableBodyCell } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
function ProjectDocumentsCellComponent(props) {
    const { count } = props, rest = __rest(props, ["count"]);
    if (count === 0) {
        return (<TableBodyCell {...rest}>
        <Chip size="medium" appearance="secondary" icon={<Falcon icon="file"/>} label={count.toString()}/>
      </TableBodyCell>);
    }
    return (<TableBodyCell {...rest}>
      <Chip size="small" appearance="info" icon={<Falcon icon="file"/>} label={count.toString()}/>
    </TableBodyCell>);
}
export const ProjectDocumentsCell = memo(ProjectDocumentsCellComponent);
